/* Guides (snippets/pl-article.liquid). Two small jobs, nothing else:
   1. Tables: each cell gets its column's header as data-label, so phones can stack a row into label / value
      lines (CSS .pl-prose__table .is-stackable) instead of scrolling sideways (owner: no sideways scroll).
   2. Contents: open beside the post where it is a sidebar (1180px and up), closed above the post on phones;
      the section on screen is marked aria-current in the list. */
(function () {
  'use strict';

  document.querySelectorAll('.pl-prose__table table').forEach(function (table) {
    var head = table.tHead && table.tHead.rows[0];
    var rows = Array.prototype.slice.call(table.rows);
    if (!head) {
      head = rows[0];
      if (!head || !head.querySelector('th')) return;
      head.classList.add('pl-prose__thead');
    }
    var labels = Array.prototype.map.call(head.cells, function (c) {
      return c.textContent.replace(/\s+/g, ' ').trim();
    });
    rows.forEach(function (row) {
      if (row === head) return;
      Array.prototype.forEach.call(row.cells, function (cell, i) {
        if (labels[i]) cell.setAttribute('data-label', labels[i]);
      });
    });
    table.classList.add('is-stackable');
  });

  var box = document.querySelector('[data-pl-toc]');
  if (!box) return;
  var wide = window.matchMedia('(min-width: 1180px)');
  var sync = function () {
    box.open = wide.matches;
  };
  sync();
  if (wide.addEventListener) wide.addEventListener('change', sync);

  var links = box.querySelectorAll('a[href^="#"]');
  if (!('IntersectionObserver' in window) || !links.length) return;
  var byId = {};
  links.forEach(function (a) {
    byId[decodeURIComponent(a.getAttribute('href').slice(1))] = a;
  });
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) {
          a.removeAttribute('aria-current');
        });
        var a = byId[e.target.id];
        if (a) a.setAttribute('aria-current', 'true');
      });
    },
    {rootMargin: '-15% 0px -75% 0px'}
  );
  document.querySelectorAll('.pl-prose h2[id]').forEach(function (h) {
    io.observe(h);
  });
})();
